import { render, staticRenderFns } from "./MduiSelect.vue?vue&type=template&id=45169e6d"
import script from "./MduiSelect.vue?vue&type=script&lang=js"
export * from "./MduiSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports